import { type UseQueryResult, useQuery } from 'react-query';
import {
  GrantService,
  PlanTypeCategoryService,
  Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO,
} from '@wealthlane/api-services/wealthlane-award-service';
import { log } from 'console';
import { useEffect } from 'react';

const useGetTransactionGrantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  plaTypeCategoryIds?: string[]
): UseQueryResult<
  Array<{
    label: string;
    value: string;
  }>,
  unknown
> => {
  const transactionGrantList = useQuery(
    ['getTransactionGrantList', plaTypeCategoryIds],
    async () => {
      return await handleRequest(GrantService.getApiAwardApiAppGrantGrants(plaTypeCategoryIds));
    },
    {
      select: (data: any) => {
        return data?.map((item: any) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionGrantList;
};

export default useGetTransactionGrantList;
